import { render, staticRenderFns } from "./FieldSimplerelation.vue?vue&type=template&id=c99fec54&"
import script from "./FieldSimplerelation.vue?vue&type=script&lang=js&"
export * from "./FieldSimplerelation.vue?vue&type=script&lang=js&"
import style0 from "./FieldSimplerelation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports